var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "request_password_reset" },
        [
          _vm.content
            ? _c(
                "v-col",
                { attrs: { order: "2", "order-sm": "1", cols: "12", sm: "6" } },
                [
                  _c("div", {
                    staticClass: "login-content",
                    domProps: { innerHTML: _vm._s(_vm.content) },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { order: "1", "order-sm": "2", cols: "12", sm: "6" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("h2", { staticClass: "primary--text title" }, [
                      _vm._v("Request Password Reset"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _vm.errors.length > 0
                        ? _c(
                            "div",
                            { staticClass: "error-message mb-4" },
                            _vm._l(_vm.errors, function (error, key) {
                              return _c(
                                "span",
                                [
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: "red",
                                        "text-color": "white",
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(error) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          class: { "mx-4": _vm.$vuetify.breakpoint.xsOnly },
                          attrs: {
                            "lazy-validation": "",
                            id: "request_password_reset",
                            method: "post",
                            action: "/request-reset",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                [
                                  _c("v-text-field", {
                                    staticClass: "border",
                                    attrs: {
                                      solo: "",
                                      "hide-details": "",
                                      id: "registrationEmail",
                                      name: "email",
                                      maxlength: "50",
                                      placeholder: "Email",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.email,
                                      callback: function ($$v) {
                                        _vm.email = $$v
                                      },
                                      expression: "email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.token,
                                expression: "token",
                              },
                            ],
                            attrs: { type: "hidden", name: "_csrf_token" },
                            domProps: { value: _vm.token },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.token = $event.target.value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { type: "submit", color: "primary" },
                                  on: { click: _vm.requestReset },
                                },
                                [
                                  _vm._v(
                                    "\n                                Request Password Reset\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }